var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenQuestion = function SvgOpenQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2737_94190)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2737_94190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 14,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 34,
    x2: 132,
    y2: 34,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 49,
    width: 124,
    height: 69,
    rx: 1.57895,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5834 57.0324C30.6636 55.9739 31.2464 55.4028 33.1437 57.3002C35.036 59.1925 34.4695 59.7736 33.4192 60.851C33.3304 60.9421 33.2382 61.0366 33.1437 61.1359L29.3081 57.3002C29.4038 57.2084 29.4953 57.1188 29.5834 57.0324ZM28.4589 58.1494L28.4569 58.1514L28.4495 58.1589C25.8482 60.7654 21.7818 64.8266 21.7818 64.8266C21.735 64.8733 21.7015 64.9317 21.6847 64.9956L20.9604 67.7508L20.9601 67.752L20.96 67.7519L20.512 69.4767C20.4787 69.6048 20.5158 69.741 20.6094 69.8346C20.7029 69.9281 20.8391 69.9652 20.9672 69.9319L22.692 69.4839L22.692 69.4839L22.6932 69.4836L25.4484 68.7593C25.5123 68.7425 25.5707 68.709 25.6174 68.6622L32.2831 61.9966L32.2852 61.9945L32.2926 61.9871L28.4589 58.1494Z",
    fill: "#4C6EF5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 58,
    x2: 129,
    y2: 58,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 70,
    x2: 129,
    y2: 70,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 83,
    x2: 128,
    y2: 83,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 96,
    x2: 128,
    y2: 96,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 109,
    x2: 128,
    y2: 109,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_2737_94190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2737_94190",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2737_94190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2737_94190",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenQuestion);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";